import { IconPhotoOff } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";

interface ProductRequestImagesCardProps {
  image?: string | null;
  galleryImages?: string[] | null;
  productName: string;
}

function toSrc(image?: string | null): string | undefined {
  if (!image) return undefined;
  if (/^(https?:|data:|blob:|\/)/i.test(image)) return image;
  const prefix = image.substring(0, 12);
  let type = "png";
  if (prefix.startsWith("/9j/")) type = "jpeg";
  else if (prefix.startsWith("UklGR")) type = "webp";
  else if (prefix.startsWith("R0lGODlh")) type = "gif";
  return `data:image/${type};base64,${image}`;
}

export function ProductRequestImagesCard({
  image,
  galleryImages,
  productName,
}: ProductRequestImagesCardProps) {
  const mainSrc = toSrc(image);
  const gallerySrcs = (galleryImages ?? []).map(toSrc).filter(Boolean) as string[];

  if (!mainSrc && gallerySrcs.length === 0) {
    return (
      <div className="rounded-2xl border border-borderDefault bg-bgWhite shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)] p-6 h-48 flex flex-col items-center justify-center gap-2">
        <IconPhotoOff size={32} className="text-textMuted" />
        <Text variant="bodySm" tone="muted">No photo available</Text>
      </div>
    );
  }

  const allSrcs = [mainSrc, ...gallerySrcs].filter(Boolean) as string[];

  return (
    <div className="rounded-2xl border border-borderDefault bg-bgWhite shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)] p-6">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {allSrcs.map((src, i) => (
          <div
            key={i}
            className="flex aspect-[4/3] items-center justify-center overflow-hidden rounded-lg border border-borderLight bg-bgLight"
          >
            <img
              src={src}
              alt={i === 0 ? productName : `${productName} ${i}`}
              className="max-h-full max-w-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
